import 'babel-polyfill'
import 'classlist-polyfill'
import Vue from 'vue'
import axios from './router/axios'
import VueAxios from 'vue-axios'
import App from './App'
import './permission' // 权限
import './error' // 日志
import router from './router/router'
import store from './store'
import { loadStyle } from './util/util'
import * as urls from '@/config/env'
import {
  baseUrl,
  iconfontUrl,
  iconfontVersion
} from '@/config/env'
import * as filters from './filters' // 全局filter
import './styles/common.scss'
// 引入avue的包
import Avue from '@smallwei/avue/lib/index.js'
// 引入avue的样式文件
import '@smallwei/avue/lib/theme-chalk/index.css'
import basicContainer from './components/basic-container/main'

import { validatenull } from '@/util/validate'
import VideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import './styles/vjs-theme.scss';
import './config/videojs-lang';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import vSelect from 'vue-select';
import _ from 'lodash';
//复制到粘贴板插件
import VueClipboard from 'vue-clipboard2';
import Clickoutside from "element-ui/src/utils/clickoutside";

Vue.use(VueClipboard);
Vue.directive('clickoutside', Clickoutside)

Vue.prototype._ = _

import mixins from './mixins';

Vue.component('v-select', vSelect)

Vue.prototype.validatenull = validatenull

Vue.use(Avue, { menuType: 'text' })

Vue.use(router)

Vue.mixin(mixins);

axios.defaults.baseURL = baseUrl
Vue.use(VueAxios, axios)

// 注册全局容器
Vue.component('basicContainer', basicContainer)
Vue.use(VideoPlayer);
Vue.use(Viewer);
Viewer.setDefaults(
  {
    title: false,
    toolbar: {
      zoomIn: 0,
      zoomOut: 0,
      oneToOne: 0,
      reset: 0,
      rotateLeft: 0,
      prev: 1,
      play: 1,
      next: 1,
      rotateRight: 0,
      flipHorizontal: 0,
      flipVertical: 0,
    },
  },
);


// 加载相关url地址
Object.keys(urls).forEach(key => {
  Vue.prototype[key] = urls[key]
})

//加载过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 动态加载阿里云字体库
iconfontVersion.forEach(ele => {
  loadStyle(iconfontUrl.replace('$key', ele))
})

Vue.config.productionTip = false
if (process.env.NODE_ENV === 'dev') {
  Vue.config.devtools = true;
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
